/* eslint-disable */
import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import { IAddTemporarilyRequest, TAddTemporarilyModel, IMappers, TAddTemporarilyResponse } from './types';
import { IAddFileResponse } from '../../entities/Models/AddFileResponse';

export const defaultConfig: TAddTemporarilyModel = {
  apiType: 'public',
  assertStatusCodes: [200],
  hostType: 'ud-api',
  method: 'POST',
  microserviceName: 'encrypted-file-manager',
  pathApi: '/v2/add-temporarily/',
  requestType: 'formData',
  responseType: 'json',
} as TAddTemporarilyModel;

export function createAddTemporarilyModel(parameters: IAddTemporarilyRequest): TAddTemporarilyModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IAddTemporarilyOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
  parameters: IAddTemporarilyRequest;
}

export async function fetchAddTemporarily<TResponse200>({
  httpApi,
  config,
  mappers,
  parameters,
}: IAddTemporarilyOptions<TResponse200>): Promise<TAddTemporarilyResponse | TResponse200> {
  const { statusCode, response, headers } = await httpApi.fetch(createAddTemporarilyModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAddFileResponse);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TAddTemporarilyResponse;
}
